import React from "react";

const GymSportsIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_264_1751"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_264_1751)">
        <path
          d="M9.96094 17.5423L9.58594 10.0007L6.66927 9.16732H1.66927C1.43316 9.16732 1.23524 9.08746 1.07552 8.92773C0.915799 8.76801 0.835938 8.5701 0.835938 8.33398C0.835938 8.09787 0.915799 7.89996 1.07552 7.74023C1.23524 7.58051 1.43316 7.50065 1.66927 7.50065H5.83594L11.0443 3.77148C11.2248 3.64648 11.4193 3.59787 11.6276 3.62565C11.8359 3.65343 12.0165 3.75065 12.1693 3.91732C12.3221 4.11176 12.3846 4.32357 12.3568 4.55273C12.329 4.7819 12.2179 4.97287 12.0234 5.12565L9.29427 7.08398H11.6693L17.6276 3.64648C17.7804 3.54926 17.9505 3.52148 18.138 3.56315C18.3255 3.60482 18.4957 3.71593 18.6484 3.89648C18.8012 4.06315 18.8637 4.25412 18.8359 4.4694C18.8082 4.68468 18.704 4.86176 18.5234 5.00065L12.0859 10.0007L11.7109 17.5423C11.6971 17.7645 11.6068 17.952 11.4401 18.1048C11.2734 18.2576 11.0582 18.334 10.7943 18.334C10.572 18.334 10.3811 18.2576 10.2214 18.1048C10.0616 17.952 9.97483 17.7645 9.96094 17.5423ZM5.0026 6.66732C4.54427 6.66732 4.15191 6.50412 3.82552 6.17773C3.49913 5.85135 3.33594 5.45898 3.33594 5.00065C3.33594 4.54232 3.49913 4.14996 3.82552 3.82357C4.15191 3.49718 4.54427 3.33398 5.0026 3.33398C5.46094 3.33398 5.8533 3.49718 6.17969 3.82357C6.50608 4.14996 6.66927 4.54232 6.66927 5.00065C6.66927 5.45898 6.50608 5.85135 6.17969 6.17773C5.8533 6.50412 5.46094 6.66732 5.0026 6.66732Z"
          fill="#2B2B2B"
        />
      </g>
    </svg>
  );
};

export default GymSportsIcon;
